var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fixed-grid has-2-cols-desktop has-1-cols-mobile" },
    [
      _c(
        "div",
        { staticClass: "grid" },
        [
          _c("div", { staticClass: "cell is-flex" }, [
            _c("article", { staticClass: "box is-flex-grow-1" }, [
              _c("div", { staticClass: "mb-6" }, [
                _c("div", { staticClass: "columns mb-0" }, [
                  _vm._m(0),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-info is-pulled-right",
                        on: { click: _vm.openSummaryModal },
                      },
                      [_vm._m(1), _c("span", [_vm._v(" View Summary ")])]
                    ),
                  ]),
                ]),
                _c("div", [
                  _vm.toBeInvoiceAssessments.length > 0
                    ? _c("p", { staticClass: "is-size-7" }, [
                        _vm._v("Select jobs to raise invoice/s"),
                      ])
                    : _vm._e(),
                  _c("table", { staticClass: "table is-fullwidth" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.columnsToBeInvoiced[0]))]),
                        _c("th", [_vm._v(_vm._s(_vm.columnsToBeInvoiced[1]))]),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(_vm.columnsToBeInvoiced[2]) + " "),
                          _c("p", { staticClass: "is-size-8" }, [
                            _vm._v("Ex GST"),
                          ]),
                        ]),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(_vm.columnsToBeInvoiced[3]) + " "),
                          _c("p", { staticClass: "is-size-8" }, [
                            _vm._v("Ex GST"),
                          ]),
                        ]),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(_vm.columnsToBeInvoiced[4]) + " "),
                          _c("p", { staticClass: "is-size-8" }, [
                            _vm._v("Ex GST"),
                          ]),
                        ]),
                        _c("th", [_vm._v(_vm._s(_vm.columnsToBeInvoiced[5]))]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(
                          _vm.toBeInvoiceAssessments,
                          function (assessment) {
                            return _c("tr", { key: assessment.subQuoteNo }, [
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(
                                  _vm._s(
                                    assessment.subQuoteNo === 0
                                      ? "Main"
                                      : `Supp-${assessment.subQuoteNo}`
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      assessment.authorisedAssessment
                                        .createdDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-right money-input",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        assessment.quotedAmount,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-right money-input",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        assessment.authorisedAmount,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-right money-input",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        assessment.invoicedAmount,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-centered is-content-width",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: assessment.selected,
                                            expression: "assessment.selected",
                                          },
                                        ],
                                        class: {
                                          "is-disabled": _vm.cannotRaiseInvoice,
                                        },
                                        attrs: {
                                          disabled: _vm.cannotRaiseInvoice,
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            assessment.selected
                                          )
                                            ? _vm._i(
                                                assessment.selected,
                                                null
                                              ) > -1
                                            : assessment.selected,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onAssessmentSelect(
                                              $event,
                                              assessment
                                            )
                                          },
                                          change: function ($event) {
                                            var $$a = assessment.selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                assessment,
                                                "selected",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _vm._m(2, true),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          }
                        ),
                        _vm.toBeInvoiceAssessments.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    colspan: _vm.columnsToBeInvoiced.length,
                                  },
                                },
                                [_vm._m(3)]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("div", [
                _c("p", { staticClass: "title mb-2" }, [
                  _vm._v("Raised Invoices"),
                ]),
                _c("div", [
                  _vm.innerValue.invoices.length > 0
                    ? _c("p", { staticClass: "is-size-7" }, [
                        _vm._v("Select invoice to view details"),
                      ])
                    : _vm._e(),
                  _c("table", { staticClass: "table is-fullwidth" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.columnsRaisedInvoices[0])),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.columnsRaisedInvoices[1])),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.columnsRaisedInvoices[2])),
                        ]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.columnsRaisedInvoices[3])),
                        ]),
                        _c("th", { staticClass: "has-text-right" }, [
                          _vm._v(_vm._s(_vm.columnsRaisedInvoices[4])),
                        ]),
                        _c("th"),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.raisedInvoice, function (invoice) {
                          return _c(
                            "tr",
                            {
                              key: invoice.invoiceId,
                              class: invoice.isSelected
                                ? "has-text-primary"
                                : "",
                            },
                            [
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(_vm._s(invoice.invoiceNo)),
                              ]),
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      invoice.invoiceDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(_vm._s(invoice.assetName)),
                              ]),
                              _c("td", { staticClass: "has-vertical-middle" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.invoiceTypeName(invoice.invoiceType)
                                  )
                                ),
                              ]),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-right money-input",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatCurrency(
                                        invoice.totalIncGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "has-vertical-middle has-text-centered is-content-width",
                                },
                                [
                                  _c("div", { staticClass: "icon-container" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "button is-primary is-small is-inverted tooltip",
                                        attrs: {
                                          "data-tooltip": "View Details",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSelectInvoice(invoice)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon is-small" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-eye mdi-24px",
                                              class: invoice.isSelected
                                                ? ""
                                                : "mdi-inactive-color",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm.raisedInvoice.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  attrs: {
                                    colspan: _vm.columnsRaisedInvoices.length,
                                  },
                                },
                                [_vm._m(4)]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "cell is-flex" }, [
            _c(
              "article",
              { staticClass: "box is-flex-grow-1" },
              [
                _vm.selectedAssessments.length > 0
                  ? _c("invoice-control", {
                      attrs: {
                        "selected-invoice": _vm.selectedInvoice,
                        assessments: _vm.selectedAssessments,
                        "is-orm-invoice-submitted": _vm.isOrmInvoiceSubmitted,
                        "is-orm-payment-authorised": _vm.isOrmPaymentAuthorised,
                        "is-orm-payment-declined": _vm.isOrmPaymentDeclined,
                        "has-raised-invoice": _vm.hasRaisedInvoice,
                      },
                      on: {
                        "raise-invoice": _vm.onRaiseInvoice,
                        "merge-invoice": _vm.onMergeInvoice,
                        "update-deductions": _vm.updateInvAmount,
                      },
                      model: {
                        value: _vm.innerValue,
                        callback: function ($$v) {
                          _vm.innerValue = $$v
                        },
                        expression: "innerValue",
                      },
                    })
                  : _vm.selectedInvoice
                  ? _c("invoice-control-view", {
                      attrs: {
                        "selected-invoice": _vm.selectedInvoice,
                        "cannot-void-invoice": _vm.cannotVoidInvoice,
                      },
                      on: { "void-invoice": _vm.deleteInvoice },
                      model: {
                        value: _vm.innerValue,
                        callback: function ($$v) {
                          _vm.innerValue = $$v
                        },
                        expression: "innerValue",
                      },
                    })
                  : _c("div", [
                      _c("p", { staticClass: "title" }, [
                        _vm._v("Invoice Control"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "content has-text-grey has-text-centered borderd-box pb-3",
                        },
                        [
                          _c("span", { attrs: { icon: "icon is-large" } }, [
                            _c("i", {
                              staticClass: "mdi mdi-48px mdi-emoticon-sad",
                            }),
                          ]),
                          _c("p", [_vm._v("Select a job to raise / view")]),
                        ]
                      ),
                    ]),
              ],
              1
            ),
          ]),
          _vm.isSummaryModalVisible
            ? _c("quote-detail-assessment-summary-modal", {
                attrs: {
                  "show-icon": true,
                  active: _vm.isSummaryModalVisible,
                  value: _vm.innerValue,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isSummaryModalVisible = $event
                  },
                  close: function ($event) {
                    _vm.isSummaryModalVisible = false
                  },
                },
              })
            : _vm._e(),
          _c(
            "BulmaMessage",
            {
              attrs: {
                type: "is-info",
                title: "Create New Invoice",
                closable: true,
              },
              on: {
                close: function ($event) {
                  _vm.isGenerateInvoiceModalActive = false
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_vm._v(" Create New Invoice ")]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "button is-danger",
                          on: {
                            click: function ($event) {
                              _vm.isGenerateInvoiceModalActive = false
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button is-primary",
                          on: {
                            click: function ($event) {
                              return _vm.handleAdd()
                            },
                          },
                        },
                        [_vm._v(" Add ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.isGenerateInvoiceModalActive,
                callback: function ($$v) {
                  _vm.isGenerateInvoiceModalActive = $$v
                },
                expression: "isGenerateInvoiceModalActive",
              },
            },
            [
              _vm.modalInvoices.some((assessment) => assessment.isInvoiced)
                ? _c("div", [
                    _c("p", { staticClass: "is-size-7 has-text-grey mb-2" }, [
                      _vm._v("Already invoiced:"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "control is-flex justify-content-start" },
                      _vm._l(
                        _vm.modalInvoices.filter(
                          (assessment) => assessment.isInvoiced
                        ),
                        function (assessment) {
                          return _c(
                            "div",
                            {
                              key: assessment.subQuoteNo,
                              staticClass: "p-2",
                              staticStyle: { opacity: "0.6" },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "checkbox toggle-style" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-curve p-smooth m-0 p-bigger pr-1",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: assessment.selected,
                                            expression: "assessment.selected",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          disabled: "",
                                        },
                                        domProps: {
                                          value: assessment,
                                          checked: Array.isArray(
                                            assessment.selected
                                          )
                                            ? _vm._i(
                                                assessment.selected,
                                                assessment
                                              ) > -1
                                            : assessment.selected,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = assessment.selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = assessment,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                assessment,
                                                "selected",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c("i", {
                                            staticClass: "icon mdi mdi-check",
                                          }),
                                          _c("label"),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        assessment.subQuoteNo === 0
                                          ? "Main"
                                          : `Supp-${assessment.subQuoteNo}`
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "is-divider" }),
              _c("p", [
                _vm._v("Available for Invoicing: main / supplementaries"),
              ]),
              _vm.modalInvoices.some((assessment) => !assessment.isInvoiced)
                ? _c("div", { staticClass: "mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "control is-flex justify-content-start" },
                      _vm._l(
                        _vm.modalInvoices.filter(
                          (assessment) => !assessment.isInvoiced
                        ),
                        function (assessment) {
                          return _c(
                            "div",
                            { key: assessment.subQuoteNo, staticClass: "p-2" },
                            [
                              _c(
                                "label",
                                { staticClass: "checkbox toggle-style" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pretty p-icon p-curve p-smooth m-0 p-bigger pr-1",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: assessment.selected,
                                            expression: "assessment.selected",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: assessment,
                                          checked: Array.isArray(
                                            assessment.selected
                                          )
                                            ? _vm._i(
                                                assessment.selected,
                                                assessment
                                              ) > -1
                                            : assessment.selected,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = assessment.selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = assessment,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    assessment,
                                                    "selected",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                assessment,
                                                "selected",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c("i", {
                                            staticClass: "icon mdi mdi-check",
                                          }),
                                          _c("label"),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        assessment.subQuoteNo === 0
                                          ? "Main"
                                          : `Supp-${assessment.subQuoteNo}`
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title mb-2" }, [_vm._v("To Be Invoiced")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-eye" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "content has-text-grey has-text-centered" },
      [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
        ]),
        _c("p", [_vm._v("Nothing")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "content has-text-grey has-text-centered" },
      [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
        ]),
        _c("p", [_vm._v("Nothing")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }